import _ from "lodash";

export default function({ dispatch, getState }) {
  return next => action => {
    if (typeof action === "function") {
      return action(dispatch, getState);
    }
    // redux原生的action处理方法
    // {type: '' , ...}
    const { promise, types, ...rest } = action;
    if (!promise) {
      return next(action);
    }

    // 如果action是types promise 这种
    // {types: [REQUEST, SUCCESS, FAILURE] , promise:()=>{}}
    const [REQUEST, SUCCESS, FAILURE] = types;
    next({ ...rest, type: REQUEST });

    const actionPromise = promise();
    actionPromise
      .then(result => {
        if (result.res_code === 0) {
          next({ ...rest, error: result, type: FAILURE });
        } else if (_.isArray(SUCCESS)) {
          SUCCESS.forEach(s => next({ ...rest, data: result.data, type: s }));
        } else {
          next({ ...rest, data: result.data, type: SUCCESS });
        }
      })
      .catch(error => {
        console.error("redux error:", error);
        next({ ...rest, error, type: FAILURE });
      });

    return actionPromise;
  };
}
